module.exports = __webpack_public_path__ + "static/contactmebitmoji-0a074dc8e407897afda064e8f9f24bc6.png";